import { Box, styled } from '@mui/material';

import { ProfileInfoBoxContainerStyle } from './ProfileInfoBox.types';

const profileInfoBoxContainerPadding = 36;

export const ProfileBoxContainer = styled(Box)(() => ({
  display: 'flex',
}));

export const ProfileInfoBoxContainer = styled('div')(
  ({ shadow, bgColor }: ProfileInfoBoxContainerStyle) => ({
    padding: `${profileInfoBoxContainerPadding}px`,
    borderRadius: '6px',
    boxShadow: `1px 1px 8px 1px ${shadow}`,

    display: 'flex',
    flexDirection: 'column',
    rowGap: '36px',

    backgroundColor: bgColor,

    '@media screen and (min-width: 1920px)': {
      padding: `${profileInfoBoxContainerPadding * 1.5}px`,
    },

    '@media screen and (max-width: 1280px)': {
      padding: `${profileInfoBoxContainerPadding / 2}px`,
    },

    '@media screen and (max-width: 640px)': {
      padding: `${profileInfoBoxContainerPadding / 2.5}px`,
    },

    '@media screen and (max-width: 1024px)': {
      width: '100%',
    },
  }),
);

export const ProfileInfoBoxTextContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '16px',
}));
